import { FC, memo } from 'react'
import { ButtonProps, Center, Text } from '@chakra-ui/react'

import { ButtonWithPermission } from 'components'

type Props = ButtonProps & {
  permissions?: string[]
  customDisableCondition?: boolean
  count?: number
}

const CountButtonWithPermission: FC<Props> = ({
  count = 0,
  customDisableCondition = null,
  permissions,
  children,
  ...props
}) => {
  return (
    <ButtonWithPermission
      customDisableCondition={customDisableCondition}
      permissions={permissions}
      variant="outline"
      leftIcon={
        <Center bg="primary" rounded="full" p={3} width="20px" height="20px">
          <Text fontWeight="bold" color="light" fontSize="xs">
            {count}
          </Text>
        </Center>
      }
      width="max-content"
      size="md"
      {...props}
    >
      {children}
    </ButtonWithPermission>
  )
}

export default memo(CountButtonWithPermission)
